/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Generate_CtaInputs */

const en_cover_letters_generate_cta = /** @type {(inputs: Cover_Letters_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Cover Letter`)
};

const de_cover_letters_generate_cta = /** @type {(inputs: Cover_Letters_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben generieren`)
};

const fr_cover_letters_generate_cta = /** @type {(inputs: Cover_Letters_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer une lettre de motivation`)
};

const es_cover_letters_generate_cta = /** @type {(inputs: Cover_Letters_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar carta de presentación`)
};

const it_cover_letters_generate_cta = /** @type {(inputs: Cover_Letters_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera lettera di presentazione`)
};

const nl_cover_letters_generate_cta = /** @type {(inputs: Cover_Letters_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer motivatiebrief`)
};

const pl_cover_letters_generate_cta = /** @type {(inputs: Cover_Letters_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj list motywacyjny`)
};

const fi_cover_letters_generate_cta = /** @type {(inputs: Cover_Letters_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo saatekirje`)
};

const da_cover_letters_generate_cta = /** @type {(inputs: Cover_Letters_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer ansøgningsbrev`)
};

const sv_cover_letters_generate_cta = /** @type {(inputs: Cover_Letters_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera personligt brev`)
};

/**
* | output |
* | --- |
* | "Generate Cover Letter" |
*
* @param {Cover_Letters_Generate_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_generate_cta = /** @type {((inputs?: Cover_Letters_Generate_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Generate_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_generate_cta(inputs)
	if (locale === "fr") return fr_cover_letters_generate_cta(inputs)
	if (locale === "es") return es_cover_letters_generate_cta(inputs)
	if (locale === "it") return it_cover_letters_generate_cta(inputs)
	if (locale === "nl") return nl_cover_letters_generate_cta(inputs)
	if (locale === "pl") return pl_cover_letters_generate_cta(inputs)
	if (locale === "fi") return fi_cover_letters_generate_cta(inputs)
	if (locale === "da") return da_cover_letters_generate_cta(inputs)
	if (locale === "sv") return sv_cover_letters_generate_cta(inputs)
	return en_cover_letters_generate_cta(inputs)
});